// app/javascript/controllers/instant_search_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "input"]

  connect() { this.timer = null }

  onInput() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.submit(), 250)
  }

  submit() {
    if (!this.hasFormTarget) return
    const value = this.inputTarget?.value?.trim()
    if (!value) return

    window.dispatchEvent(new CustomEvent("header-search:loading"))
    // ensure ?instant=1 is present
    let instant = this.formTarget.querySelector('input[name="instant"]')
    if (!instant) {
      instant = document.createElement("input")
      instant.type = "hidden"
      instant.name = "instant"
      instant.value = "1"
      this.formTarget.appendChild(instant)
    } else {
      instant.value = "1"
    }
    // request Turbo Stream response
    this.formTarget.requestSubmit()
  }
}
